"use strict";

exports.__esModule = true;
exports.ColorPicker = void 0;
var _react = _interopRequireDefault(require("react"));
var _ColorPickerFormGroup = require("../../../Form/ColorPicker/ColorPickerFormGroup");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ColorPicker = exports.ColorPicker = function ColorPicker(props) {
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path,
    selectedColor = props.selectedColor,
    setSelectedColor = props.setSelectedColor;
  var handleColorChange = function handleColorChange(color) {
    var measureChartSeries = element.props.measureChartSeries;
    if (measureChartSeries.length > 0) {
      var updatedSeries = measureChartSeries.map(function (item) {
        return Object.assign({}, item, {
          color: color
        });
      });
      elementEditor.setProp(path, "measureChartSeries", updatedSeries);
    }
    setSelectedColor(color);
  };
  return /*#__PURE__*/_react["default"].createElement(_ColorPickerFormGroup.ColorPickerFormGroup, {
    color: selectedColor,
    setColor: handleColorChange
  });
};